import React from "react";
import PersonService from "../../Services/Person.service";
let SYSTEM_USER_PROMISE = null;
const SYSTEM_USER = { user: null };
export const SYSTEM_USER_ID = "42608b17-f522-46b0-b302-a7e006aaf34e";
export default function useSystemUser() {
    const [systemUser, setSystemUser] = React.useState(() => SYSTEM_USER.user);
    React.useEffect(() => {
        if (!SYSTEM_USER_PROMISE) {
            SYSTEM_USER_PROMISE = PersonService.getPeopleByPersonId(SYSTEM_USER_ID).then((people) => people[0]);
        }
        SYSTEM_USER_PROMISE.then((s) => {
            SYSTEM_USER.user = s;
            setSystemUser(s);
        });
    }, []);
    return systemUser;
}
